import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  ButtonBase,
  Card,
  CardContent,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,
  Divider,
  IconButton,
  Alert,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  Stack,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SendIcon from '@mui/icons-material/Send';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useLocation, useNavigate } from 'react-router-dom';
import { createOrder } from '../../../../../services/Admin/OrdersApi';
import { getClientMenus } from '../../../../../services/Clint/UserOrdersApi';
import { getTablesWithOrders } from '../../../../../services/Admin/OrdersApi';
import { resolveImageUrl } from '../../../../../services/indexMediaBaseUrl';
import LocalOrderMenuSection from './LocalOrderMenuSection';
import NuvvyCharacter from '../../../../../components/NuvvyCharacter';
import logo from '../../../../../Assets/logo.png';

const nuvvyChoiceMessages = [
  'تعالى نكتشف الـNUVVY اللي يناسب مزاجك النهارده',
  'نفتخر في NUVVY أننا أول كافيه في مصر يوفر للعميل تجربة إنشاء مشروب مخصص له.',
  'تعالى نكتشف الـNUVVY اللي يناسب مزاجك النهارده',
  'تحب الـNUVVY بتاعك يكون عباره عن اية؟',
];

const nuvvyCharacterStates = ['talking', 'happy', 'talking', 'wave'];

const LocalScreenMakeOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHandledIncomingDrink = useRef(false);
  const customerStageRef = useRef(null);
  const orderDetailsStageRef = useRef(null);
  const cartStageRef = useRef(null);
  const menuStageRef = useRef(null);

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const [orderMode, setOrderMode] = useState(null);
  const [characterState, setCharacterState] = useState('wave');
  const [choiceMessageIndex, setChoiceMessageIndex] = useState(0);
  const choiceMessage = nuvvyChoiceMessages[choiceMessageIndex];

  // Customer Information
  const [customerName, setCustomerName] = useState('');
  const [phone, setPhone] = useState('');
  const [phone2, setPhone2] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [address2, setAddress2] = useState('');
  
  // Order Details
  const [orderType, setOrderType] = useState('tables'); // delivery, takeaway, tables
  const [selectedTable, setSelectedTable] = useState('');
  
  // Items
  const [products, setProducts] = useState([]);
  const [drinks, setDrinks] = useState([]);
  const [tables, setTables] = useState([]);
  const [cart, setCart] = useState([]);
  
  // UI State
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', type: 'success' });
  const [addItemDialog, setAddItemDialog] = useState(false);
  const [selectedItemType, setSelectedItemType] = useState('product'); // product or drink
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemQuantity, setItemQuantity] = useState(1);
  const [itemNote, setItemNote] = useState('');
  const [menuTab, setMenuTab] = useState('products');

  // Load Data
  useEffect(() => {
    loadMenuData();
    loadTables();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderMode) return undefined;

    setChoiceMessageIndex(0);
    setCharacterState('talking');

    const interval = window.setInterval(() => {
      setChoiceMessageIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % nuvvyChoiceMessages.length;
        setCharacterState(nuvvyCharacterStates[nextIndex] || 'talking');
        return nextIndex;
      });
    }, 4300);

    return () => window.clearInterval(interval);
  }, [orderMode]);

  useEffect(() => {
    const approvedDrinkResponse = location.state?.approvedDrink;
    const selectedDessert = location.state?.selectedDessert;

    if ((!approvedDrinkResponse && !selectedDessert) || hasHandledIncomingDrink.current) {
      return;
    }

    const approvedDrink = approvedDrinkResponse?.drink;
    const nextCartItems = [];

    if (approvedDrink?.id) {
      nextCartItems.push({
        id: `drink_${approvedDrink.id}_${Date.now()}`,
        product_id: null,
        drink_id: approvedDrink.id,
        name: approvedDrink.drink_name || approvedDrink.name || 'مشروب مخصص',
        quantity: 1,
        price: toNumber(approvedDrink.price),
        note: approvedDrink.taste || '',
        status: 'pending',
      });
    }

    if (selectedDessert?.product_id || selectedDessert?.id || selectedDessert?.value) {
      const productId = selectedDessert.product_id || selectedDessert.id || selectedDessert.value;

      nextCartItems.push({
        id: `product_${productId}_${Date.now()}`,
        product_id: productId,
        drink_id: null,
        name: selectedDessert.name || selectedDessert.label || 'إضافة مع المشروب',
        quantity: 1,
        price: toNumber(selectedDessert.price),
        note: selectedDessert.category || '',
        status: 'pending',
      });
    }

    if (!nextCartItems.length) {
      return;
    }

    hasHandledIncomingDrink.current = true;

    setOrderMode('custom');
    setCart((prev) => [...prev, ...nextCartItems]);
    showNotification(
      selectedDessert
        ? 'تم استلام المشروب المعتمد والإضافة المختارة داخل السلة'
        : 'تم استلام المشروب المعتمد وإضافته إلى السلة',
      'success'
    );
  }, [location.state]);

  const loadMenuData = async () => {
    try {
      const response = await getClientMenus();
      setProducts(response.data?.products || []);
      setDrinks(response.data?.drinks || []);
    } catch (error) {
      console.error('Error loading menu:', error);
      showNotification('حدث خطأ أثناء تحميل القائمة', 'error');
    }
  };

  const loadTables = async () => {
    try {
      const response = await getTablesWithOrders();
      setTables(response.data || []);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  // Add Item to Cart
  const handleAddItemClick = (type) => {
    setSelectedItemType(type);
    setSelectedItem(null);
    setItemQuantity(1);
    setItemNote('');
    setAddItemDialog(true);
  };

  const handleQuickAddProduct = (product) => {
    setSelectedItemType('product');
    setSelectedItem(product);
    setItemQuantity(1);
    setItemNote('');
    setAddItemDialog(true);
  };

  const handleQuickAddDrink = (drink) => {
    setSelectedItemType('drink');
    setSelectedItem(drink);
    setItemQuantity(1);
    setItemNote('');
    setAddItemDialog(true);
  };

  const getItemImage = (item) => {
    if (!item?.image) return '/placeholder.png';
    return resolveImageUrl(item.image);
  };

  const isVisibleItem = (item) => item?.status !== 0 && item?.status !== '0';

  const activeProducts = products.filter(isVisibleItem);
  const activeDrinks = drinks.filter(isVisibleItem);

  const isStageOneComplete = Boolean(customerName.trim() && phone.trim());
  const isStageTwoComplete = orderType !== 'tables' || Boolean(selectedTable);
  const currentStage = !isStageOneComplete
    ? 0
    : !isStageTwoComplete
      ? 1
      : 2;

  const stageLabels = ['معلومات العميل', 'تفاصيل الطلب', 'السلة والمنيو'];
  const stageGuidance = [
    'ابدأ بإدخال اسم العميل ورقم الهاتف للانتقال بسلاسة إلى المرحلة التالية.',
    'اختر نوع الطلب، وإذا كان الطلب طاولة اختر اسم الطاولة المطلوبة.',
    'أضف الأصناف من المنيو وراجع السلة ثم أرسل الطلب.',
  ];

  const scrollToStage = (stageIndex) => {
    const refs = [customerStageRef, orderDetailsStageRef, cartStageRef];
    const targetRef = refs[stageIndex];
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleConfirmAddItem = () => {
    if (!selectedItem) {
      showNotification('الرجاء اختيار عنصر', 'warning');
      return;
    }

    const newItem = {
      id: `${selectedItemType}_${selectedItem.id}_${Date.now()}`,
      product_id: selectedItemType === 'product' ? selectedItem.id : null,
      drink_id: selectedItemType === 'drink' ? selectedItem.id : null,
      name: selectedItem.name || selectedItem.drink_name,
      quantity: itemQuantity,
      price: toNumber(selectedItem.price),
      note: itemNote,
      status: 'pending',
    };

    setCart([...cart, newItem]);
    setAddItemDialog(false);
    showNotification('تمت إضافة العنصر للسلة', 'success');
  };

  // Remove Item from Cart
  const handleRemoveItem = (itemId) => {
    setCart(cart.filter(item => item.id !== itemId));
  };

  // Update Item Quantity
  const handleUpdateQuantity = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    setCart(cart.map(item => 
      item.id === itemId ? { ...item, quantity: newQuantity } : item
    ));
  };

  // Calculate Total
  const calculateTotal = () => {
    return cart.reduce(
      (sum, item) => sum + (toNumber(item.price) * toNumber(item.quantity)),
      0
    );
  };

  // Submit Order
  const handleSubmitOrder = async () => {
    // Validation
    
    if (!phone.trim()) {
      showNotification('الرجاء إدخال رقم الهاتف', 'error');
      return;
    }
    if (cart.length === 0) {
      showNotification('الرجاء إضافة عناصر للطلب', 'error');
      return;
    }
    if (orderType === 'tables' && !selectedTable) {
      showNotification('الرجاء اختيار اسم الطاولة', 'error');
      return;
    }

    setLoading(true);

    try {
      const orderPayload = {
        order_type: orderType,
        type: 'screen',
        customer_id: null,
        name: customerName,
        phone: phone,
        phone2: phone2 || null,
        phone3: null,
        email: email || null,
        address: orderType === 'delivery' ? address : null,
        address2: orderType === 'delivery' ? address2 : null,
        address3: null,
        table_id: orderType === 'tables' ? parseInt(selectedTable) : null,
        captain_order_id: null,
        delivery_id: null,
        date: new Date().toISOString().slice(0, 19).replace('T', ' '),
        items: cart.map(item => ({
          product_id: item.product_id,
          drink_id: item.drink_id,
          quantity: toNumber(item.quantity),
          price: toNumber(item.price),
          note: item.note || null,
          status: item.status,
        })),
      };

      await createOrder(orderPayload);
      
      showNotification('تم إنشاء الطلب بنجاح!', 'success');
      
      // Reset Form
      resetForm();
      setOrderMode(null);
    } catch (error) {
      console.error('Error creating order:', error);
      showNotification(error.message || 'حدث خطأ أثناء إنشاء الطلب', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Reset Form
  const resetForm = () => {
    setCustomerName('');
    setPhone('');
    setPhone2('');
    setEmail('');
    setAddress('');
    setAddress2('');
    setOrderType('tables');
    setSelectedTable('');
    setCart([]);
  };

  const handleBackToModeSelection = () => {
    resetForm();
    setOrderMode(null);
  };

  // Show Notification
  const showNotification = (message, type) => {
    setNotification({ open: true, message, type });
  };
    useEffect(() => {
    document.title = 'Nuvvy-شاشة الطلب';
  }, []);
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {orderMode && (
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 4,
          mb: 2,
          px: { xs: 2, md: 4 },
          py: { xs: 3, md: 4 },
          textAlign: 'center',
          background: 'linear-gradient(125deg, #f8f3eb 0%, #eef7ff 45%, #eefaf2 100%)',
          border: '1px solid rgba(16, 94, 61, 0.12)',
          boxShadow: '0 16px 38px rgba(14, 34, 54, 0.08)',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle at 10% 20%, rgba(25, 118, 210, 0.18) 0%, transparent 40%), radial-gradient(circle at 92% 80%, rgba(46, 125, 50, 0.16) 0%, transparent 42%)',
            pointerEvents: 'none',
          },
          '@keyframes heroFadeUp': {
            from: {
              opacity: 0,
              transform: 'translateY(18px)',
            },
            to: {
              opacity: 1,
              transform: 'translateY(0)',
            },
          },
          '@keyframes lineExpand': {
            from: {
              width: 0,
              opacity: 0,
            },
            to: {
              width: '120px',
              opacity: 1,
            },
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 900,
              letterSpacing: '0.4px',
              mb: 1,
              color: '#0f2d45',
              animation: 'heroFadeUp 700ms ease-out both',
            }}
          >
            Nuvvy - تجربة لا تُنسى
          </Typography>

          <Box
            sx={{
              height: '3px',
              borderRadius: 999,
              background: 'linear-gradient(90deg, #1976d2, #2e7d32)',
              mx: 'auto',
              mb: 1.5,
              animation: 'lineExpand 700ms ease-out 150ms both',
            }}
          />

          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              maxWidth: 860,
              mx: 'auto',
              lineHeight: 1.9,
              animation: 'heroFadeUp 700ms ease-out 240ms both',
            }}
          >
            نفتخر في NUVVY اننا اول كافيه في مصر بيوفر للعميل تجربة انشاء مشروب مخصص له
          </Typography>
        </Box>
      </Box>
      )}


      {!orderMode ? (
        <>
        <Box
          dir="rtl"
          sx={{
            minHeight: { xs: 'calc(100vh - 72px)', md: 'calc(100vh - 96px)' },
            display: 'grid',
            placeItems: 'center',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 4,
            px: { xs: 1.5, sm: 2.5, md: 5 },
            py: { xs: 3, md: 5 },
            background:
              'linear-gradient(135deg, #f8fbf4 0%, #f1f7f3 48%, #fff8ec 100%)',
            border: '1px solid rgba(47, 87, 65, 0.14)',
            boxShadow: '0 24px 70px rgba(23, 53, 37, 0.10)',
            '@keyframes choiceFadeUp': {
              from: {
                opacity: 0,
                transform: 'translateY(14px)',
              },
              to: {
                opacity: 1,
                transform: 'translateY(0)',
              },
            },
            '@keyframes logoBreathe': {
              '0%, 100%': {
                transform: 'translateY(0) scale(1)',
                boxShadow: '0 16px 36px rgba(23, 53, 37, 0.16)',
              },
              '50%': {
                transform: 'translateY(-4px) scale(1.03)',
                boxShadow: '0 22px 46px rgba(23, 53, 37, 0.24)',
              },
            },
            '@keyframes featuredChoiceGlow': {
              '0%, 100%': {
                boxShadow: '0 18px 38px rgba(156, 39, 176, 0.18)',
              },
              '50%': {
                boxShadow: '0 24px 52px rgba(156, 39, 176, 0.30)',
              },
            },
            '@keyframes featuredIconPulse': {
              '0%, 100%': {
                transform: 'scale(1) rotate(0deg)',
              },
              '50%': {
                transform: 'scale(1.08) rotate(-7deg)',
              },
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              inset: 0,
              background:
                'radial-gradient(circle at 14% 18%, rgba(234, 247, 181, 0.55), transparent 34%), radial-gradient(circle at 88% 82%, rgba(47, 87, 65, 0.12), transparent 34%)',
              pointerEvents: 'none',
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              zIndex: 1,
              width: '100%',
              maxWidth: 1120,
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1.2fr 0.8fr' },
              alignItems: 'center',
              gap: { xs: 3, md: 5 },
            }}
          >
            <Stack
              spacing={1.5}
              sx={{
                order: { xs: 2, md: 1 },
                textAlign: { xs: 'center', md: 'right' },
              }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1.25,
                  alignSelf: { xs: 'center', md: 'flex-start' },
                  p: 1,
                  pr: 1.4,
                  borderRadius: 999,
                  border: '1px solid rgba(47, 87, 65, 0.16)',
                  background: 'rgba(255, 255, 255, 0.78)',
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 16px 36px rgba(23, 53, 37, 0.13)',
                  animation: 'choiceFadeUp 520ms ease 620ms both',
                  transition: 'transform 180ms ease, box-shadow 180ms ease',
                  '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: '0 20px 42px rgba(23, 53, 37, 0.18)',
                  },
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="Nuvvy"
                  onMouseEnter={() => setCharacterState('happy')}
                  onMouseLeave={() => setCharacterState(nuvvyCharacterStates[choiceMessageIndex] || 'talking')}
                  sx={{
                    width: { xs: 46, sm: 52 },
                    height: { xs: 46, sm: 52 },
                    objectFit: 'contain',
                    borderRadius: '50%',
                    p: 0.45,
                    background: 'linear-gradient(145deg, #f8ffd8, #ffffff)',
                    border: '1px solid rgba(47, 87, 65, 0.14)',
                    animation: 'logoBreathe 3.8s ease-in-out infinite',
                    cursor: 'pointer',
                  }}
                />
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ fontWeight: 950, color: '#173525', lineHeight: 1 }}>
                    NUVVY
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
                    اصنع مزاجك بنفسك
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="overline"
                sx={{
                  color: 'success.dark',
                  fontWeight: 900,
                  letterSpacing: 0,
                  animation: 'choiceFadeUp 520ms ease 850ms both',
                }}
              >
                Nuvvy Experience
              </Typography>

              <Box sx={{ display: { xs: 'none', md: 'block' }, mb: 0.5 }}>
                <Typography
                  variant="h4"
                  sx={{
                    maxWidth: 620,
                    fontWeight: 950,
                    lineHeight: 1.25,
                    color: '#173525',
                    animation: 'choiceFadeUp 560ms ease 920ms both',
                  }}
                >
                  تعالى نكتشف الـNUVVY اللي يناسب مزاجك النهارده
                </Typography>
              </Box>

              <Stack spacing={1.25} sx={{ width: '100%', maxWidth: 660, mx: { xs: 'auto', md: 0 } }}>
                <ButtonBase
                  onClick={() => navigate('/makedrink')}
                  onMouseEnter={() => setCharacterState('pointLeft')}
                  onMouseLeave={() => setCharacterState(nuvvyCharacterStates[choiceMessageIndex] || 'talking')}
                  sx={{
                    width: '100%',
                    textAlign: 'right',
                    borderRadius: 2.5,
                    overflow: 'visible',
                    animation: 'choiceFadeUp 520ms ease 1000ms both',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      position: 'relative',
                      overflow: 'hidden',
                      width: '100%',
                      p: { xs: 1.8, sm: 2.25 },
                      pt: { xs: 2.6, sm: 2.6 },
                      borderRadius: 2.5,
                      border: '2px solid rgba(156, 39, 176, 0.42)',
                      outline: '1px solid rgba(255, 255, 255, 0.85)',
                      outlineOffset: '-5px',
                      background:
                        'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,246,231,0.98) 42%, rgba(252,239,255,0.98) 100%)',
                      transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
                      cursor: 'pointer',
                      animation: 'featuredChoiceGlow 2.8s ease-in-out infinite',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        background:
                          'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.62) 45%, transparent 70%)',
                        transform: 'translateX(120%) skewX(-18deg)',
                        transition: 'transform 650ms ease',
                        pointerEvents: 'none',
                      },
                      '&:hover': {
                        transform: { xs: 'none', md: 'translateX(-7px) scale(1.015)' },
                        borderColor: '#9c27b0',
                        boxShadow: '0 28px 58px rgba(156, 39, 176, 0.32)',
                        '&::before': {
                          transform: 'translateX(-120%) skewX(-18deg)',
                        },
                      },
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 10,
                        left: 12,
                        px: 1.25,
                        py: 0.35,
                        borderRadius: 999,
                        color: '#5f176b',
                        fontWeight: 950,
                        fontSize: { xs: '0.72rem', sm: '0.78rem' },
                        background: 'linear-gradient(135deg, #fff6d7, #f0d4ff)',
                        border: '1px solid rgba(156, 39, 176, 0.22)',
                        boxShadow: '0 8px 18px rgba(156, 39, 176, 0.14)',
                        zIndex: 1,
                      }}
                    >
                      جرّب الجديد
                    </Box>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: { xs: 52, sm: 58 },
                          height: { xs: 52, sm: 58 },
                          borderRadius: 2,
                          background: 'linear-gradient(145deg, #9c27b0, #ffb74d)',
                          color: '#fff',
                          display: 'grid',
                          placeItems: 'center',
                          flexShrink: 0,
                          boxShadow: '0 14px 26px rgba(156, 39, 176, 0.25)',
                          '& svg': {
                            animation: 'featuredIconPulse 1.9s ease-in-out infinite',
                          },
                        }}
                      >
                        <AutoFixHighIcon />
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 950, color: '#22152b' }}>
                          اصنع الـ NUVVY الخاص بك
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                          كوّن مشروب جديد على مزاجك واختار مكوناته بنفسك.
                        </Typography>
                      </Box>
                      <KeyboardArrowLeftIcon sx={{ color: 'secondary.main', flexShrink: 0 }} />
                    </Stack>
                  </Paper>
                </ButtonBase>

                <ButtonBase
                  onClick={() => setOrderMode('menu')}
                  onMouseEnter={() => setCharacterState('pointRight')}
                  onMouseLeave={() => setCharacterState(nuvvyCharacterStates[choiceMessageIndex] || 'talking')}
                  sx={{
                    width: '100%',
                    textAlign: 'right',
                    borderRadius: 2,
                    overflow: 'hidden',
                    animation: 'choiceFadeUp 520ms ease 1150ms both',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      width: '100%',
                      p: { xs: 1.6, sm: 2 },
                      borderRadius: 2,
                      borderColor: 'rgba(47, 87, 65, 0.22)',
                      background:
                        'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(244,251,246,0.98) 100%)',
                      transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
                      cursor: 'pointer',
                      '&:hover': {
                        transform: { xs: 'none', md: 'translateX(-5px)' },
                        borderColor: 'success.main',
                        boxShadow: '0 18px 38px rgba(47, 87, 65, 0.14)',
                      },
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 46,
                          height: 46,
                          borderRadius: 1.5,
                          bgcolor: 'success.light',
                          color: 'success.dark',
                          display: 'grid',
                          placeItems: 'center',
                          flexShrink: 0,
                        }}
                      >
                        <RestaurantMenuIcon />
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 950, color: '#173525' }}>
                          استكشف المنيو
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                          اختار مشروب جاهز من قائمة Nuvvy.
                        </Typography>
                      </Box>
                      <KeyboardArrowLeftIcon sx={{ color: 'success.main', flexShrink: 0 }} />
                    </Stack>
                  </Paper>
                </ButtonBase>
              </Stack>
            </Stack>

            <Box
              sx={{
                order: { xs: 1, md: 2 },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <NuvvyCharacter
                state={characterState}
                size="large"
                showBubble
                message={choiceMessage}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            minHeight: { xs: 'calc(100vh - 120px)', md: 'calc(100vh - 160px)' },
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 4,
            background: 'linear-gradient(135deg, #f7f4ef 0%, #edf4ff 55%, #f3fbf7 100%)',
            '&::before': {
              content: '""',
              position: 'absolute',
              width: 340,
              height: 340,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(25,118,210,0.18) 0%, rgba(25,118,210,0) 70%)',
              top: -100,
              right: -90,
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              width: 300,
              height: 300,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(46,125,50,0.16) 0%, rgba(46,125,50,0) 70%)',
              bottom: -110,
              left: -80,
            },
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: 3,
              textAlign: 'center',
              width: '100%',
              maxWidth: 1080,
              position: 'relative',
              zIndex: 1,
              border: '1px solid',
              borderColor: 'rgba(25, 118, 210, 0.15)',
              boxShadow: '0 14px 45px rgba(18, 38, 63, 0.12)',
              backdropFilter: 'blur(2px)',
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Nuvvy AI Cafe"
              sx={{
                width: { xs: 96, md: 120 },
                height: { xs: 96, md: 120 },
                objectFit: 'contain',
                mb: 1,
                filter: 'drop-shadow(0 10px 18px rgba(0,0,0,0.16))',
              }}
            />
            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
              كيف تريد بدء الطلب؟
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              اختر ما إذا كان العميل يريد مشروبًا مميزًا ومخصصًا له أو يريد الاختيار مباشرة من المنيو.
            </Typography>

            <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Card
                onClick={() => navigate('/makedrink')}
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  border: '1px solid',
                  borderColor: 'rgba(156, 39, 176, 0.22)',
                  background: 'linear-gradient(180deg, #fff 0%, #faf5ff 100%)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 18px 32px rgba(156, 39, 176, 0.18)',
                    borderColor: 'secondary.main',
                    background: 'linear-gradient(180deg, #fff 0%, #f6ecff 100%)',
                  },
                }}
              >
                <CardContent sx={{ py: 5 }}>
                  <AutoFixHighIcon sx={{ fontSize: 72, color: 'secondary.main', mb: 2 }} />
                  <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                    إنشاء مشروب مميز ومخصص
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    مناسب عندما يريد العميل مشروبًا خاصًا أو من قائمة المشروبات المميزة.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card
                onClick={() => setOrderMode('menu')}
                sx={{
                  height: '100%',
                  cursor: 'pointer',
                  border: '1px solid',
                  borderColor: 'rgba(25, 118, 210, 0.22)',
                  background: 'linear-gradient(180deg, #fff 0%, #eff6ff 100%)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 18px 32px rgba(25, 118, 210, 0.2)',
                    borderColor: 'primary.main',
                    background: 'linear-gradient(180deg, #fff 0%, #e9f3ff 100%)',
                  },
                }}
              >
                <CardContent sx={{ py: 5 }}>
                  <RestaurantMenuIcon sx={{ fontSize: 72, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                    الاختيار من المنيو
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    مناسب عندما يريد العميل اختيار صنف أو مشروب مباشر من القائمة المتاحة.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            </Grid>
          </Paper>
        </Box>
        </>
      ) : (
        <>
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'flex-start' }}>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              onClick={handleBackToModeSelection}
            >
              رجوع للاختيار الأول
            </Button>
          </Box>

          <Paper
            elevation={0}
            sx={{
              mb: 3,
              p: { xs: 1.5, md: 2 },
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
            }}
          >
            <Stepper activeStep={currentStage} alternativeLabel>
              {stageLabels.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <Alert severity="info" sx={{ mt: 2 }}>
              {stageGuidance[currentStage]}
            </Alert>

            <Box sx={{ mt: 1.5, display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
              {stageLabels.map((label, idx) => (
                <Button
                  key={label}
                  size="small"
                  variant={idx === currentStage ? 'contained' : 'outlined'}
                  onClick={() => scrollToStage(idx)}
                >
                  {`اذهب إلى ${label}`}
                </Button>
              ))}
            </Box>
          </Paper>

      <Grid container spacing={3}>
        {/* Customer Information */}
        <Grid item xs={12} ref={customerStageRef}>
          <Card
            sx={{
              height: '100%',
              border: '1px solid',
              borderColor: currentStage === 0 ? 'primary.main' : 'divider',
              boxShadow: currentStage === 0 ? '0 0 0 3px rgba(25, 118, 210, 0.08)' : 'none',
            }}
          >
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Chip
                  label="المرحلة الأولى"
                  color="primary"
                  size="small"
                  sx={{ mb: 1, fontWeight: 700 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  معلومات العميل
                </Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="اسم العميل *"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="رقم الهاتف *"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="رقم هاتف إضافي"
                    value={phone2}
                    onChange={(e) => setPhone2(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="البريد الإلكتروني"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Order Details */}
        <Grid item xs={12} ref={orderDetailsStageRef}>
          <Card
            sx={{
              height: '100%',
              border: '1px solid',
              borderColor: currentStage === 1 ? 'primary.main' : 'divider',
              boxShadow: currentStage === 1 ? '0 0 0 3px rgba(25, 118, 210, 0.08)' : 'none',
            }}
          >
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Chip
                  label="المرحلة الثانية"
                  color="primary"
                  size="small"
                  sx={{ mb: 1, fontWeight: 700 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  تفاصيل الطلب
                </Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>نوع الطلب</InputLabel>
                    <Select
                      value={orderType}
                      label="نوع الطلب"
                      onChange={(e) => setOrderType(e.target.value)}
                    >
                      <MenuItem value="tables">طاولة</MenuItem>
                      <MenuItem value="takeaway">تيك أواي</MenuItem>
                      <MenuItem value="delivery">توصيل</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {orderType === 'delivery' && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="العنوان"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        multiline
                        rows={2}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="تفاصيل إضافية للعنوان"
                        value={address2}
                        onChange={(e) => setAddress2(e.target.value)}
                      />
                    </Grid>
                  </>
                )}

                {orderType === 'tables' && (
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>اسم الطاولة *</InputLabel>
                      <Select
                        value={selectedTable}
                        label="اسم الطاولة *"
                        onChange={(e) => setSelectedTable(e.target.value)}
                        onOpen={loadTables}
                      >
                        {tables.map((table) => (
                          <MenuItem
                            key={table.id}
                            value={table.id}
                            disabled={Boolean(table.active_order)}
                          >
                            {table.name || `طاولة ${table.id}`}
                            {table.active_order ? ' (مشغولة)' : ''}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Cart */}
        <Grid item xs={12} ref={cartStageRef}>
          <Card
            sx={{
              border: '1px solid',
              borderColor: currentStage === 2 ? 'primary.main' : 'divider',
              boxShadow: currentStage === 2 ? '0 0 0 3px rgba(25, 118, 210, 0.08)' : 'none',
            }}
          >
            <CardContent>
              <Box sx={{ mb: 2 }}>
                <Chip
                  label="المرحلة الثالثة"
                  color="primary"
                  size="small"
                  sx={{ mb: 1, fontWeight: 700 }}
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  <ShoppingCartIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                  السلة ({cart.length})
                </Typography>
                <Box>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => handleAddItemClick('drink')}
                    color="secondary"
                  >
                    {orderMode === 'custom' ? 'إضافة مشروب مخصص' : 'إضافة مشروب'}
                  </Button>
                </Box>
              </Box>

              <Divider sx={{ mb: 2 }} />

              {cart.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography variant="body1" color="text.secondary">
                    السلة فارغة. قم بإضافة عناصر للطلب.
                  </Typography>
                </Box>
              ) : (
                <>
                  <TableContainer component={Paper} variant="outlined">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>الصنف</TableCell>
                          <TableCell>النوع</TableCell>
                          <TableCell align="center">الكمية</TableCell>
                          <TableCell align="right">السعر</TableCell>
                          <TableCell align="right">الإجمالي</TableCell>
                          <TableCell>ملاحظات</TableCell>
                          <TableCell align="center">إجراءات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {cart.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>
                              <Chip
                                label={item.product_id ? 'منتج' : 'مشروب AI'}
                                color={item.product_id ? 'primary' : 'secondary'}
                                size="small"
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <IconButton
                                  size="small"
                                  onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)}
                                >
                                  <RemoveIcon fontSize="small" />
                                </IconButton>
                                <Typography sx={{ mx: 2 }}>{item.quantity}</Typography>
                                <IconButton
                                  size="small"
                                  onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)}
                                >
                                  <AddIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            </TableCell>
                            <TableCell align="right">{toNumber(item.price).toFixed(2)} ج.م</TableCell>
                            <TableCell align="right">
                              {(toNumber(item.price) * toNumber(item.quantity)).toFixed(2)} ج.م
                            </TableCell>
                            <TableCell>{item.note || '-'}</TableCell>
                            <TableCell align="center">
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveItem(item.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                      الإجمالي: {calculateTotal().toFixed(2)} ج.م
                    </Typography>
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<SendIcon />}
                      onClick={handleSubmitOrder}
                      disabled={loading || cart.length === 0}
                    >
                      {loading ? 'جاري الإرسال...' : 'إرسال الطلب'}
                    </Button>
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>

        <LocalOrderMenuSection
          sectionRef={menuStageRef}
          isActiveStage={currentStage === 2}
          stageLabel="المرحلة الثالثة"
          menuTab={menuTab}
          setMenuTab={setMenuTab}
          activeProducts={activeProducts}
          activeDrinks={activeDrinks}
          onQuickAddProduct={handleQuickAddProduct}
          onQuickAddDrink={handleQuickAddDrink}
          getItemImage={getItemImage}
          toNumber={toNumber}
        />
      </Grid>
        </>
      )}

      {/* Add Item Dialog */}
      <Dialog 
        open={addItemDialog} 
        onClose={() => setAddItemDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          إضافة {selectedItemType === 'product' ? 'منتج' : 'مشروب AI'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {selectedItemType === 'drink' ? (
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>اختر الصنف</InputLabel>
                  <Select
                    value={selectedItem?.id || ''}
                    label="اختر الصنف"
                    onChange={(e) => {
                      const item = activeDrinks.find(i => i.id === e.target.value);
                      setSelectedItem(item);
                    }}
                  >
                    {activeDrinks.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name || item.drink_name} - {item.price || 0} ج.م
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="الصنف المختار"
                  value={selectedItem?.name || '-'}
                  disabled
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="number"
                label="الكمية"
                value={itemQuantity}
                onChange={(e) => setItemQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                inputProps={{ min: 1 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="ملاحظات (اختياري)"
                value={itemNote}
                onChange={(e) => setItemNote(e.target.value)}
                multiline
                rows={2}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddItemDialog(false)}>إلغاء</Button>
          <Button variant="contained" onClick={handleConfirmAddItem}>
            إضافة
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.type}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default LocalScreenMakeOrder;
